import _asyncToGenerator from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { useEventCallback } from '@mui/material/utils';
import { useGridApiMethod } from '../../utils/useGridApiMethod';
import { GridRowModes, GridEditModes, GridCellModes } from '../../../models/gridEditRowModel';
import { useGridSelector } from '../../utils/useGridSelector';
import { gridColumnDefinitionsSelector } from '../columns/gridColumnsSelector';
import { gridEditRowsStateSelector } from './gridEditRowsSelector';
import { gridFocusCellSelector } from '../focus/gridFocusStateSelector';
import { useGridApiOptionHandler, useGridApiEventHandler } from '../../utils/useGridApiEventHandler';
export var useGridRowEditing = function useGridRowEditing(apiRef, props) {
  var _props$experimentalFe2, _props$experimentalFe4;
  var focusTimeout = React.useRef(null);
  var nextFocusedCell = React.useRef(null);
  var columns = useGridSelector(apiRef, gridColumnDefinitionsSelector);
  var buildCallback = function buildCallback(callback) {
    return function () {
      if (props.editMode === GridEditModes.Row) {
        callback.apply(void 0, arguments);
      }
    };
  };
  var setRowMode = React.useCallback(function (id, mode) {
    if (mode === apiRef.current.getRowMode(id)) {
      return;
    }
    apiRef.current.setState(function (state) {
      var newEditRowsState = _extends({}, state.editRows);
      if (mode === GridRowModes.Edit) {
        newEditRowsState[id] = {};
        columns.forEach(function (column) {
          var cellParams = apiRef.current.getCellParams(id, column.field);
          if (cellParams.isEditable) {
            newEditRowsState[id][column.field] = {
              value: cellParams.value
            };
          }
        });
      } else {
        delete newEditRowsState[id];
      }
      return _extends({}, state, {
        editRows: newEditRowsState
      });
    });
    apiRef.current.forceUpdate();
  }, [apiRef, columns]);
  var getRowMode = React.useCallback(function (id) {
    if (props.editMode === GridEditModes.Cell) {
      return GridRowModes.View;
    }
    var editRowsState = gridEditRowsStateSelector(apiRef.current.state);
    return editRowsState[id] ? GridRowModes.Edit : GridRowModes.View;
  }, [apiRef, props.editMode]);
  var commitRowChange = React.useCallback(function (id) {
    var event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _props$experimentalFe;
    if (props.editMode === GridEditModes.Cell) {
      throw new Error("MUI: You can't commit changes when the edit mode is 'cell'.");
    }
    apiRef.current.unstable_runPendingEditCellValueMutation(id);
    var model = apiRef.current.getEditRowsModel();
    var editRowProps = model[id];
    if (!editRowProps) {
      throw new Error("MUI: Row at id: ".concat(id, " is not being edited."));
    }
    if ((_props$experimentalFe = props.experimentalFeatures) != null && _props$experimentalFe.preventCommitWhileValidating) {
      var isValid = Object.keys(editRowProps).reduce(function (acc, field) {
        return acc && !editRowProps[field].isValidating && !editRowProps[field].error;
      }, true);
      if (!isValid) {
        return false;
      }
    }
    var hasFieldWithError = Object.values(editRowProps).some(function (value) {
      return !!value.error;
    });
    if (hasFieldWithError) {
      return false;
    }
    var fieldsWithValidator = Object.keys(editRowProps).filter(function (field) {
      var column = apiRef.current.getColumn(field);
      return typeof column.preProcessEditCellProps === 'function';
    });
    if (fieldsWithValidator.length > 0) {
      var row = apiRef.current.getRow(id);
      var validatorErrors = fieldsWithValidator.map(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(field) {
          var column, newEditCellProps;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                column = apiRef.current.getColumn(field);
                _context.next = 3;
                return Promise.resolve(column.preProcessEditCellProps({
                  id: id,
                  row: row,
                  props: editRowProps[field]
                }));
              case 3:
                newEditCellProps = _context.sent;
                apiRef.current.unstable_setEditCellProps({
                  id: id,
                  field: field,
                  props: newEditCellProps
                });
                return _context.abrupt("return", newEditCellProps.error);
              case 6:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
      return Promise.all(validatorErrors).then(function (errors) {
        if (errors.some(function (error) {
          return !!error;
        })) {
          return false;
        }
        apiRef.current.publishEvent('rowEditCommit', id, event);
        return true;
      });
    }
    apiRef.current.publishEvent('rowEditCommit', id, event);
    return true;
  }, [apiRef, props.editMode, (_props$experimentalFe2 = props.experimentalFeatures) == null ? void 0 : _props$experimentalFe2.preventCommitWhileValidating]);
  var setRowEditingEditCellValue = React.useCallback(function (params) {
    var model = apiRef.current.getEditRowsModel();
    var editRow = model[params.id];
    var row = apiRef.current.getRow(params.id);
    var isValid = true;
    return new Promise(function (resolve) {
      Object.keys(editRow).forEach(/*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(field) {
          var column, editCellProps;
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                column = apiRef.current.getColumn(field);
                editCellProps = field === params.field ? {
                  value: params.value
                } : editRow[field]; // setEditCellProps runs the value parser and returns the updated props
                editCellProps = apiRef.current.unstable_setEditCellProps({
                  id: params.id,
                  field: field,
                  props: _extends({}, editCellProps, {
                    isValidating: true
                  })
                });
                if (!column.preProcessEditCellProps) {
                  _context2.next = 7;
                  break;
                }
                _context2.next = 6;
                return Promise.resolve(column.preProcessEditCellProps({
                  id: params.id,
                  row: row,
                  props: _extends({}, editCellProps, {
                    value: field === params.field ? apiRef.current.unstable_parseValue(params.id, field, params.value) : editCellProps.value
                  })
                }));
              case 6:
                editCellProps = _context2.sent;
              case 7:
                if (editCellProps.error) {
                  isValid = false;
                }
                apiRef.current.unstable_setEditCellProps({
                  id: params.id,
                  field: field,
                  props: _extends({}, editCellProps, {
                    isValidating: false
                  })
                });
              case 9:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }());
      resolve(isValid);
    });
  }, [apiRef]);
  var rowEditingApi = {
    setRowMode: setRowMode,
    getRowMode: getRowMode,
    commitRowChange: commitRowChange,
    unstable_setRowEditingEditCellValue: setRowEditingEditCellValue
  };
  useGridApiMethod(apiRef, rowEditingApi, 'EditRowApi');
  var handleCellKeyDown = React.useCallback(/*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(params, event) {
      var cellMode, isEditable, isEditMode, rowParams, _props$experimentalFe3, isValid;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (!(event.which === 229)) {
              _context3.next = 2;
              break;
            }
            return _context3.abrupt("return");
          case 2:
            cellMode = params.cellMode, isEditable = params.isEditable;
            if (isEditable) {
              _context3.next = 5;
              break;
            }
            return _context3.abrupt("return");
          case 5:
            isEditMode = cellMode === GridCellModes.Edit;
            rowParams = apiRef.current.getRowParams(params.id);
            if (!isEditMode) {
              _context3.next = 20;
              break;
            }
            if (!(event.key === 'Enter')) {
              _context3.next = 17;
              break;
            }
            _context3.next = 11;
            return apiRef.current.commitRowChange(params.id);
          case 11:
            isValid = _context3.sent;
            if (!(!isValid && (_props$experimentalFe3 = props.experimentalFeatures) != null && _props$experimentalFe3.preventCommitWhileValidating)) {
              _context3.next = 14;
              break;
            }
            return _context3.abrupt("return");
          case 14:
            apiRef.current.publishEvent('rowEditStop', rowParams, event);
            _context3.next = 18;
            break;
          case 17:
            if (event.key === 'Escape') {
              apiRef.current.publishEvent('rowEditStop', rowParams, event);
            }
          case 18:
            _context3.next = 21;
            break;
          case 20:
            if (event.key === 'Enter') {
              apiRef.current.publishEvent('rowEditStart', rowParams, event);
            }
          case 21:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function (_x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }(), [apiRef, (_props$experimentalFe4 = props.experimentalFeatures) == null ? void 0 : _props$experimentalFe4.preventCommitWhileValidating]);
  var handleCellDoubleClick = React.useCallback(function (params, event) {
    if (!params.isEditable) {
      return;
    }
    var rowParams = apiRef.current.getRowParams(params.id);
    apiRef.current.publishEvent('rowEditStart', rowParams, event);
  }, [apiRef]);
  var handleEditCellPropsChange = React.useCallback(function (params) {
    var row = apiRef.current.getRow(params.id);
    var model = apiRef.current.getEditRowsModel();
    var editRow = model[params.id];
    Object.keys(editRow).forEach(/*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(field) {
        var column, editCellProps, newEditCellProps;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              column = apiRef.current.getColumn(field);
              if (!column.preProcessEditCellProps) {
                _context4.next = 9;
                break;
              }
              editCellProps = field === params.field ? params.props : editRow[field];
              _context4.next = 5;
              return Promise.resolve(column.preProcessEditCellProps({
                id: params.id,
                row: row,
                props: editCellProps
              }));
            case 5:
              newEditCellProps = _context4.sent;
              apiRef.current.unstable_setEditCellProps({
                id: params.id,
                field: field,
                props: newEditCellProps
              });
              _context4.next = 10;
              break;
            case 9:
              if (field === params.field) {
                apiRef.current.unstable_setEditCellProps(params);
              }
            case 10:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      return function (_x5) {
        return _ref4.apply(this, arguments);
      };
    }());
  }, [apiRef]);
  var handleRowEditStart = React.useCallback(function (params) {
    apiRef.current.setRowMode(params.id, GridRowModes.Edit);
  }, [apiRef]);
  var handleRowEditStop = React.useCallback(function (params, event) {
    apiRef.current.setRowMode(params.id, GridRowModes.View);
    if (event.key === 'Enter') {
      apiRef.current.publishEvent('cellNavigationKeyDown', params, event);
    }
  }, [apiRef]);
  var handleRowEditCommit = React.useCallback(function (id) {
    var model = apiRef.current.getEditRowsModel();
    var editRow = model[id];
    if (!editRow) {
      throw new Error("MUI: Row at id: ".concat(id, " is not being edited."));
    }
    var row = apiRef.current.getRow(id);
    if (row) {
      var rowUpdate = _extends({}, row);
      Object.keys(editRow).forEach(function (field) {
        var column = apiRef.current.getColumn(field);
        var value = editRow[field].value;
        if (column.valueSetter) {
          rowUpdate = column.valueSetter({
            row: rowUpdate,
            value: value
          });
        } else {
          rowUpdate[field] = value;
        }
      });
      apiRef.current.updateRows([rowUpdate]);
    }
  }, [apiRef]);
  var handleCellFocusIn = React.useCallback(function (params) {
    nextFocusedCell.current = params;
  }, []);
  var commitPropsAndExit = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(params, event) {
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            if (!(params.cellMode === GridCellModes.View)) {
              _context6.next = 2;
              break;
            }
            return _context6.abrupt("return");
          case 2:
            nextFocusedCell.current = null;
            focusTimeout.current = setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
              var _nextFocusedCell$curr, rowParams;
              return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                while (1) switch (_context5.prev = _context5.next) {
                  case 0:
                    if (!(((_nextFocusedCell$curr = nextFocusedCell.current) == null ? void 0 : _nextFocusedCell$curr.id) !== params.id)) {
                      _context5.next = 5;
                      break;
                    }
                    _context5.next = 3;
                    return apiRef.current.commitRowChange(params.id, event);
                  case 3:
                    rowParams = apiRef.current.getRowParams(params.id);
                    apiRef.current.publishEvent('rowEditStop', rowParams, event);
                  case 5:
                  case "end":
                    return _context5.stop();
                }
              }, _callee5);
            })));
          case 4:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return function commitPropsAndExit(_x6, _x7) {
      return _ref5.apply(this, arguments);
    };
  }();
  var handleCellFocusOut = useEventCallback(function (params, event) {
    commitPropsAndExit(params, event);
  });
  var handleColumnHeaderDragStart = useEventCallback(function () {
    var cell = gridFocusCellSelector(apiRef);
    if (!cell) {
      return;
    }
    var params = apiRef.current.getCellParams(cell.id, cell.field);
    commitPropsAndExit(params, {});
  });
  useGridApiEventHandler(apiRef, 'cellKeyDown', buildCallback(handleCellKeyDown));
  useGridApiEventHandler(apiRef, 'cellDoubleClick', buildCallback(handleCellDoubleClick));
  useGridApiEventHandler(apiRef, 'editCellPropsChange', buildCallback(handleEditCellPropsChange));
  useGridApiEventHandler(apiRef, 'rowEditStart', buildCallback(handleRowEditStart));
  useGridApiEventHandler(apiRef, 'rowEditStop', buildCallback(handleRowEditStop));
  useGridApiEventHandler(apiRef, 'rowEditCommit', buildCallback(handleRowEditCommit));
  useGridApiEventHandler(apiRef, 'cellFocusIn', buildCallback(handleCellFocusIn));
  useGridApiEventHandler(apiRef, 'cellFocusOut', buildCallback(handleCellFocusOut));
  useGridApiEventHandler(apiRef, 'columnHeaderDragStart', buildCallback(handleColumnHeaderDragStart));
  useGridApiOptionHandler(apiRef, 'rowEditCommit', props.onRowEditCommit);
  useGridApiOptionHandler(apiRef, 'rowEditStart', props.onRowEditStart);
  useGridApiOptionHandler(apiRef, 'rowEditStop', props.onRowEditStop);
};